module.exports = __webpack_public_path__ + "static/media/badgeWeb@3x.fb827e29.png";